import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    NumberColumn,
    ExternalDespatchLinkColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin operator', 'operatorFrom'),
        new TextColumn('Origin IMPC', 'impcFrom'),
        new TextColumn('Destination IMPC', 'impcTo'),
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'receptacleId').withWidth(270)),
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'despatchId').withWidth(200)),
        new NumberColumn('Final bag indicator', 'finalBag'),
        new TextColumn('Last leg transport mode', 'transportMode'),
        new TextColumn('Product', 'product'),
        new TextColumn('Subclass', 'subclass'),
        new DateTimeColumn('Despatch close date', 'despatchCloseDate'),
        new TextColumn('Despatch close weekday', 'despatchCloseDateWeekDay'),
        new DateTimeColumn('Planned arrival date', 'plannedArrivalDate'),
        new TextColumn('Planned arrival weekday', 'plannedArrivalDateWeekDay'),
        new TextColumn('RESDES transp', 'resdesTransportMode'),
        new TextColumn('RESCON transp', 'resconTransportMode'),
        new TextColumn('PREDES transp', 'predesTransportMode'),
        new TextColumn('PREDES', 'predes'),
        new TextColumn('RESDES', 'resdes'),
        new TextColumn('(From origin DO) CARDIT', 'cardit'),
        new TextColumn('(From origin DO) PRECON', 'precon'),
        new NumberColumn('Number of operators destination\n' +
          'received PRECON from', 'numOpersDestRcvPreconFrom'),
        new TextColumn('Operators destination received\n' +
          'PRECON from', 'opersDestRcvPreconFrom'),
        new TextColumn('Destination received PRECON\n' +
          'from just one operator', 'destRcvPreconFromOneOper'),
        new TextColumn('Destination sent RESCON to\n' +
          'PRECON sender', 'destSentResconToPreconSender'),
      ],
    },
  ];
};
